import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Badge, Box, Button, Card, CardBody, CardHeader, Container, Flex, FormControl, FormLabel, Grid, IconButton, Image, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Text, Textarea, useColorModeValue, useDisclosure, useToast } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
import { DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import MyPaginantion from '../../components/MyPagination';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { PiPlusBold } from 'react-icons/pi';
import empty from '../../assets/images/bell.png'
import animationData from '../../assets/lotties/notif.json'
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import MyPagination from '../../components/MyPagination';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

function GestNotifications() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const [loadingData, setLoadingData] = useState()

    const { user, setUser } = useStateContext();
    const [notificationsData, setNotificationsData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [id, setId] = useState(null);
    const toast = useToast()
    const cancelRef = React.useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState('');
    const [notifData, setNotifData] = useState();
    const [notifId, setNotifId] = useState('');

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const [selectedCible, setSelectedCible] = useState(null);
    const [selectedC, setSelectedC] = useState('');
    const [checkLengthData, setCheckLengthData] = useState(false)

    //search variable
    const [searchTerm, setSearchTerm] = useState('');

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [changeModal, setChangeModal] = useState(true)

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };

    const handleCibleChange = (ev) => {
        setSelectedCible(ev.target.value)

    }
    const [paginationData, setPaginationData] = useState()

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 5;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////


    //get the data
    useEffect(() => {
        setLoadingData(true)

        axiosClient.get(`/notificationsAdmin/getAllNotifications/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&cible=${selectedC}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setNotificationsData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });

    }, [pageSize, currentPage, searchTerm, selectedC])

    function update() {
        setLoadingData(true)

        axiosClient.get(`/notificationsAdmin/getAllNotifications/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&cible=${selectedC}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setNotificationsData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });
    }

    //search method
    // const filteredData = useCallback(() => {
    //     return notificationsData.filter((row) => {
    //         return row.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //             row.content.toString().toLowerCase().includes(searchTerm.toString().toLowerCase()) ||
    //             row.cible.toString().toLowerCase().includes(searchTerm.toString().toLowerCase())

    //     });
    // }, [notificationsData, searchTerm]);

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/notificationsAdmin/${id}/`)
            .then((response) => {
                setNotificationsData((prevData) => prevData.filter((row) => row.id !== id));
                // setNotificationsData(notificationsData.filter((row) => row.id !== id));
                toast({
                    description: t("la notification est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
                update()
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const AjoutNotification = () => {
        if (!title || title.trim() === "") {
            setMessage(t("Veuillez remplir le titre"))
            return;
        }
        if (!content || content.trim() === "") {
            setMessage(t("Veuillez remplir le contenu"))
            return;
        }
        const formData = new FormData()
        formData.append("title", title)
        formData.append("cible", selectedCible)
        formData.append("content", content)


        axiosClient.post('/notificationsAdmin/', formData)
            .then((response) => {
                setNotificationsData([response.data, ...notificationsData]);
                setTitle('')
                setContent('')
                setSelectedCible('')
                setMessage("")
                update()

                toast({
                    description: t(`La notificiation est ajoutée avec succès`),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        onClose()
    }

    const UpdateNotif = (id) => {

        const formData = new FormData();
        if (title) formData.append("title", title)
        if (selectedCible) formData.append("cible", selectedCible)
        if (content) formData.append("content", content)

        axiosClient.patch(`/notificationsAdmin/${id}/`, formData).then(() => {

            update()

            toast({
                description: t(`La notification est modifiée avec succès`),
                status: 'success',
                duration: 2000,
                isClosable: true,
                variant: 'left-accent',
                position: 'bottom-right'
            })
            setTitle('')
            setContent('')
            setSelectedCible('')
            setMessage("")
        })

        onClose()
    }
    const myColor = useColorModeValue("gray.50", "gray.700");

    return (
        <Box>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span>Notifications</span> </Text>
                    <Button onClick={() => {
                        onOpen()
                        setChangeModal(true)
                    }}
                        leftIcon={<PiPlusBold color='#49b1cc' />} variant='solid'>
                        {t("Ajouter Une notification")}
                    </Button>
                </Box>

            </Flex>
            {(paginationData?.length === 0 && !searchTerm && !selectedC) ? (
                <Flex mb={'10'} mt={20} gap={2} flexDirection={'column'} h={"100%"} w={"100%"} alignItems={"center"} justifyContent={"center"}>
                    <Text color={'gray.500'} fontWeight={"semibold"}>{t("Il n'y a pas de notifications à afficher")}</Text>
                    <Image opacity={0.7} w={{ base: "150px", md: "200px", lg: "200px" }} src={empty} />
                </Flex>
            ) :
                <Flex direction='column' p={{ base: 0, lg: 7 }}>

                    <Grid templateColumns={{ sm: "1fr", md: "1fr", lg: "2fr 1fr " }} justify={"center"} gap='22px'>

                        <Card

                            bg={"none"}
                            border={'none'}
                            shadow={'none'}
                            display={'flex'}
                        >

                            <CardBody px='2px' >

                                <Flex
                                    px={5}
                                    justifyContent="end"
                                    alignItems="center"
                                    direction={{ base: 'column', md: 'row' }}
                                >
                                    <Select borderRadius={"5"} bg={myColor} fontSize={{ base: 13, lg: 16 }} size={"sm"} w={{ base: '100%', md: "25%" }} mr={{ base: 0, md: 5 }} mb={4} value={selectedC} onChange={(e) => setSelectedC(e.target.value)}>
                                        <option value="">{t("Tout")}</option>
                                        <option value="Partenaire">{t("Partenaire")}</option>
                                        <option value="Client">Client</option>
                                        <option value="Both">Client / {t("Partenaire")}</option>
                                    </Select>
                                    <InputGroup size={"sm"} w={{ base: '100%', md: "40%" }}>
                                        <InputLeftElement
                                            pointerEvents='none'
                                            children={<SearchIcon color='gray.300' />}
                                        />
                                        <Input
                                            borderRadius={"5"}
                                            placeholder={t("Recherche...")}
                                            value={searchTerm}
                                            bg={myColor}
                                            onChange={(e) => {
                                                setCurrentPage(0)
                                                setSearchTerm(e.target.value)
                                            }}
                                            mb={4}
                                            sx={{
                                                marginLeft: 'auto',
                                            }}
                                        />  </InputGroup>

                                </Flex>
                                <Flex
                                    direction={{ base: 'column', md: 'row' }}
                                    align={{ base: 'stretch', md: 'center' }}
                                    justify={{ base: 'flex-start', md: 'space-between' }}
                                    p={5}
                                >

                                    <Flex
                                        direction="column"
                                        width={{ base: "100%", lg: "100%" }}
                                        justify={{ base: 'flex-start', md: 'space-between' }}

                                    >

                                        {(paginationData?.length !== 0) &&
                                            notificationsData.map((row,key) => (

                                                <Stack
                                                key={key}
                                                    bg={myColor}
                                                    mb={2}
                                                    rounded={'lg'}
                                                    p={5}
                                                    boxShadow={'md'}
                                                    alignItems={'start'}
                                                    justify="space-between"
                                                // as={"Button"}

                                                >
                                                    <Flex direction="row"
                                                        justify="space-between"
                                                        ml={'auto'}
                                                        width="full">
                                                        <Stack display={'flex'} flexDirection={{ base: "column", md: "row" }} align={'center'}>
                                                            <Text fontSize={'lg'} fontWeight="semibold">{row.title}</Text>
                                                            <Stack mt={1}>
                                                                <Badge
                                                                    rounded={'lg'}
                                                                    colorScheme={row.cible === "Client" ? "blue" :
                                                                        row.cible === "Partenaire" ? "green" :
                                                                            row.cible === "Both" ? "yellow" : ""}
                                                                >
                                                                    {row.cible === "Client" ? "Client" :
                                                                        row.cible === "Partenaire" ? t("Partenaire") :
                                                                            row.cible === "Both" ? `Client / ${t("Partenaire")}` : ""}
                                                                </Badge>
                                                            </Stack>
                                                        </Stack>
                                                        <Text mt={2} fontSize={'xs'} color={'gray.500'}>{new Date(row.date_creation).toLocaleDateString(t('fr-FR'), { hour: '2-digit', minute: '2-digit' })}</Text>

                                                    </Flex>

                                                    <Flex
                                                        direction="row"
                                                        width="full"
                                                        ml={'auto'}
                                                        justify="space-between">
                                                        <Text fontSize={{ base: 'sm' }} textAlign={'left'} w={{ base: "80%", md: "80%", lg: "85%" }}>
                                                            {row.content}

                                                        </Text>

                                                        <Flex align={'center'} mt={1} direction={'column'}>

                                                            <Flex direction={"row"} >
                                                                {/* <EditIcon
                                                        size="sm"
                                                        cursor='pointer'
                                                        onClick={() => {
                                                            setChangeModal(false)
                                                            setNotifData(row)
                                                            setNotifId(row.id)
                                                            onOpen()

                                                        }}

                                                        color='green'
                                                        
                                                    /> */}

                                                                {(user.role === "SUPERADMIN" || user.role === "ADMIN") && <DeleteIcon
                                                                    ml={5}
                                                                    cursor='pointer'
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        setId(row.id);
                                                                        onOpenAlert();
                                                                    }}
                                                                    color='#e53e3e'
                                                                // icon={<DeleteIcon />}>
                                                                />
                                                                }

                                                            </Flex>


                                                        </Flex>
                                                    </Flex>
                                                </Stack>
                                            ))}
                                        {((searchTerm && paginationData?.length === 0) || (selectedC && paginationData?.length === 0) || (checkLengthData)) && (

                                            <Flex flexDirection={"column"} p={{ base: 5, md: 10, lg: 20 }} w={"100%"} justify={"center"} alignItems={'center'}>
                                                <Text color={'gray.500'} fontWeight={"semibold"}>{t("Aucune notification correspondante n'a été trouvée.")}</Text>
                                                {/* <Image opacity={0.5} src={notfound}></Image> */}
                                            </Flex>
                                        )}
                                        <Flex justify="space-between" align="center" w="100%">
                                            <Box flex="1">
                                                <MyPagination
                                                    paginationData={paginationData}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    PAGE_SIZE={pageSize}
                                                />
                                            </Box>


                                        </Flex>
                                    </Flex>


                                </Flex>
                            </CardBody>
                        </Card>
                        <Flex w={'100%'} h={'100%'} display={{ base: "none", lg: "flex" }} justify={"center"} align={'center'}>
                            <Flex >
                                <Lottie speed={0.5} options={defaultOptions} />
                            </Flex>
                        </Flex>
                    </Grid>
                </Flex>}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(id)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            {changeModal ?
                <Modal isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')
                    setSelectedCible('')
                    setTitle('')
                    setContent('')
                    setSelectedCible('')
                }}>
                    <ModalOverlay />

                    <ModalContent>

                        <ModalHeader>{t("Ajout d'une notification")}</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>

                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Titre")}</FormLabel>
                                        <Input maxLength={50} name="type" onChange={e => setTitle(e.target.value)} placeholder={t('Titre de notification...')} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>Message</FormLabel>
                                        <Textarea height={"100px"} resize={"none"} type='text' maxLength={250} name="message" onChange={e => setContent(e.target.value)} placeholder={t('Message de notification...')} />
                                    </FormControl>
                                    <FormControl isRequired >
                                        <FormLabel>{t("Cible")}</FormLabel>
                                        <Select onChange={handleCibleChange} placeholder={t('Sélectionner une option')}>
                                            <option value='Client'>Client</option>
                                            <option value='Partenaire'>{t("Partenaire")}</option>
                                            <option value='Both'>Client / {t("Partenaire")}</option>
                                        </Select>
                                    </FormControl>


                                </Flex>
                            </Flex>

                        </ModalBody>

                        <ModalFooter>
                            {(!title || !content || !selectedCible)
                                ?
                                <Button colorScheme='blue' isDisabled
                                >
                                    {t("Ajouter")}
                                </Button>
                                :
                                <Button colorScheme='blue'
                                    onClick={AjoutNotification}
                                >
                                    {t("Ajouter")}
                                </Button>
                            }
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                :
                <Modal isOpen={isOpen} onClose={() => {
                    onClose()
                    setMessage('')
                    setSelectedCible('')
                    setTitle('')
                    setContent('')
                    setSelectedCible('')
                }}>
                    <ModalOverlay />

                    <ModalContent>

                        <ModalHeader>{t("Modification de notification")}</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>

                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Titre")}</FormLabel>
                                        <Input maxLength={50} defaultValue={notifData.title} name="title" onChange={e => setTitle(e.target.value)} placeholder={t('Titre de notification...')} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>Message</FormLabel>
                                        <Textarea height={"100px"} defaultValue={notifData.content} resize={"none"} type='text' maxLength={250} name="message" onChange={e => setContent(e.target.value)} placeholder={t('Message de notification...')} />
                                    </FormControl>
                                    <FormControl isRequired >
                                        <FormLabel>{t("Cible")}</FormLabel>
                                        <Select onChange={handleCibleChange} defaultValue={notifData.cible} placeholder={t('Sélectionner une option')}>
                                            <option value='Client'>Client</option>
                                            <option value='Partenaire'>{t("Partenaire")}</option>
                                            <option value='Both'>Client / {t("Partenaire")}</option>
                                        </Select>
                                    </FormControl>


                                </Flex>
                            </Flex>

                        </ModalBody>

                        <ModalFooter>


                            <Button colorScheme='blue'
                                onClick={() => UpdateNotif(notifId)}
                            >
                                {t("Modifier")}
                            </Button>

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            }

        </Box>
    )
}

export default GestNotifications